// extracted by mini-css-extract-plugin
export var style_component = "TwoColumnListLoader-module--style_component--84c3d";
export var style_placeholder = "TwoColumnListLoader-module--style_placeholder--5cc1a";